import React from 'react'
import { GradientButton, Text, theme } from '@vatom/wombo'
import { Spinner, useColorMode } from 'native-base'

interface IProcessButtonProps {
  onPress: () => void
  isLoading: boolean
  isDisabled: boolean
  label: string
}

export const ProcessButton = ({ onPress, isLoading, isDisabled, label }: IProcessButtonProps) => {
  return (
    <GradientButton
      colorScheme={isDisabled ? 'gray' : 'brand'}
      // px={4}
      w="100%"
      justifyContent="center"
      onPress={onPress}
      disabled={isDisabled}
    >
      {isLoading ? (
        <Spinner color="black" fontSize="18px" py={3} />
      ) : (
        <Text
          _dark={{
            color: 'white'
          }}
          _light={{
            color: 'white'
          }}
          fontFamily="Inter-SemiBold"
          alignSelf="center"
          py={2}
          fontSize="18px"
        >
          {label}
        </Text>
      )}
    </GradientButton>
  )
}
export default ProcessButton
